import React from "react";
import "./cta.css";

const CTA = () => {
  return (
    <div className="gpt3__cta section__margin">
      <div className="gpt3__cta-content">
        <p>Request Early Access to Get Started</p>
        <h3>Register today & start exploring the endless possiblities.</h3>
      </div>

      <button type="button" className="glow">
        Get Started
      </button>
    </div>
  );
};

export default CTA;
